import {
  SECTION_ANALYSIS,
  SECTION_BUDGET,
  SECTION_BUDGET_SETTINGS,
  SECTION_EMPLOYEE_MANAGEMENT,
  SECTION_OVERVIEW,
  SECTION_USERS,
  SECTION_WORKFORCE_SETTINGS,
} from "common/routes/sections/main.sections";

import {
  BUDGET_URL,
  CREATE_ASSUMPTIONS,
  CREATE_COMPANY,
  CREATE_SCHEDULES,
  CREATE_TEMPLATES,
  CREATE_WORKFORCE,
  OWNER_ASSIGNATION,
  SELECT_ACCOUNTS,
  START_BUDGET,
} from "features/budget/budget.sections";
import {
  OVERVIEW_BUDGET,
  OVERVIEW_URL,
} from "features/overview/state/overview.sections";
import {
  USER_FORM,
  USERS_URL,
} from "features/coordinator-user/state/user.sections";
import {
  EMPLOYEE_MANAGEMENT_URL,
  WORKFORCE_DATA_PREVIEW,
  WORKFORCE_SETTINGS_URL,
  WORKFORCE_TEMPLATE_SETUP,
} from "features/workforce/workforce-sections";

const OPTIONAL_PARAMS = "(?:\\w+/)?";

const ALL_SECTIONS = new Map([
  [`^/${SECTION_BUDGET_SETTINGS.path}`, SECTION_BUDGET_SETTINGS],
  [
    `^${OVERVIEW_URL}${OVERVIEW_BUDGET.path}${OPTIONAL_PARAMS}$`,
    OVERVIEW_BUDGET,
  ],
  [`^/${SECTION_OVERVIEW.path}`, SECTION_OVERVIEW],
  [`^${BUDGET_URL}$`, SECTION_BUDGET],
  [`^${BUDGET_URL}${START_BUDGET.path}${OPTIONAL_PARAMS}$`, START_BUDGET],
  [`^${BUDGET_URL}${SELECT_ACCOUNTS.path}$`, SELECT_ACCOUNTS],
  [`^${BUDGET_URL}${CREATE_ASSUMPTIONS.path}$`, CREATE_ASSUMPTIONS],
  [`^${BUDGET_URL}${CREATE_COMPANY.path}$`, CREATE_COMPANY],
  [`^${BUDGET_URL}${CREATE_SCHEDULES.path}$`, CREATE_SCHEDULES],
  [`^${BUDGET_URL}${CREATE_TEMPLATES.path}$`, CREATE_TEMPLATES],
  [`^${BUDGET_URL}${CREATE_WORKFORCE.path}$`, CREATE_WORKFORCE],
  [`^${BUDGET_URL}${OWNER_ASSIGNATION.path}$`, OWNER_ASSIGNATION],
  [`^${USERS_URL}$`, SECTION_USERS],
  [`^${USERS_URL}${USER_FORM.path}${OPTIONAL_PARAMS}$`, USER_FORM],
  [`^${WORKFORCE_SETTINGS_URL}$`, SECTION_WORKFORCE_SETTINGS],
  [`^${EMPLOYEE_MANAGEMENT_URL}$`, SECTION_EMPLOYEE_MANAGEMENT],
  [
    `^${EMPLOYEE_MANAGEMENT_URL}${WORKFORCE_DATA_PREVIEW.path}$`,
    WORKFORCE_DATA_PREVIEW,
  ],
  [
    `^${EMPLOYEE_MANAGEMENT_URL}${WORKFORCE_TEMPLATE_SETUP.path}$`,
    WORKFORCE_TEMPLATE_SETUP,
  ],
  [`^/${SECTION_ANALYSIS.path}`, SECTION_ANALYSIS],
]);

export default ALL_SECTIONS;
